<template>
  <div :class="$style.container">
    <!-- -------------- -->
    <!-- PROFILE TOGGLE -->
    <!-- -------------- -->

    <NsHeaderProfileToggle
      :dropdown-open="profilePopupOpen"
      :greeting="translations.greeting"
      :hide-sign-up="hideSignUp"
      :sign-in-label="translations.signIn"
      :sign-up-label="translations.signUp"
      @toggle="handleDropdownToggle"
    />

    <!-- ------------- -->
    <!-- DESKTOP POPUP -->
    <!-- ------------- -->

    <div
      :class="[
        $style.triangle,
        { [$style.open]: profilePopupOpen, [$style.loggedIn]: isLoggedIn }
      ]"
    />
    <div :class="[$style.popup, { [$style.open]: profilePopupOpen }]">
      <div
        :class="[$style.content, { [$style.loggedIn]: isLoggedIn }]"
        @mouseleave="handlePopupMouseleave"
      >
        <NsHeaderProfile
          :hide-sign-up="hideSignUp"
          :profile-menu="profileMenu"
          :sign-out-url="signOutUrl"
          :sign-up-url="signUpUrl"
          :translations="translations"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { events } from "@nuskin/ns-util";
import { UserService } from "@nuskin/ns-account";

import NsHeaderProfile from "./NsHeaderProfile.vue";
import NsHeaderProfileToggle from "./NsHeaderProfileToggle.vue";

export default {
  name: "NsHeaderProfileDropdown",
  components: {
    NsHeaderProfile,
    NsHeaderProfileToggle
  },
  props: {
    /**
     * Hides the Signup text and link
     */
    hideSignUp: Boolean,
    /**
     * List of potential navigation links
     */
    profileMenu: {
      type: Array,
      default: () => []
    },
    /**
     * The url where signout link takes you
     */
    signOutUrl: {
      type: String,
      default: ""
    },
    /**
     * The url where signup link takes you
     */
    signUpUrl: {
      type: String,
      default: ""
    },
    /**
     * Translations for component
     * Required keys: id, greeting, enjoyLoyalty, newCustomerLabel,
     * signUpTodayLabel, signIn, signOut, signUp
     */
    translations: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    isLoggedIn: UserService.isLoggedIn(),
    profilePopupOpen: false
  }),
  mounted() {
    this.startEventListeners();
  },
  methods: {
    handlePopupMouseleave() {
      this.profilePopupOpen = false;
    },
    handleDropdownToggle() {
      this.profilePopupOpen = !this.profilePopupOpen;
    },
    startEventListeners() {
      // LOGIN EVENTS
      events.subscribe(events.authentication.LOGIN_COMPLETE, () => {
        this.isLoggedIn = UserService.isLoggedIn();
      });

      events.subscribe(events.authentication.LOGOUT, () => {
        this.isLoggedIn = false;
      });
    }
  }
};
</script>

<style lang="scss" module>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/other";
@use "~@nuskin/ns-core-styles/src/scss/global.mixins";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";

.container,
.container * {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  font-family: map.get(typographyVariables.$typography, font-family-primary);
}

.container {
  position: relative;
  margin-left: 15px;
}

.triangle {
  position: absolute;
  bottom: -18px;
  left: 50%;
  width: 24px;
  height: 24px;
  overflow: hidden;
  transition: map.get(other.$otherUtils, global-transition);
  z-index: 700;
  opacity: 0;
  visibility: hidden;

  &.open {
    opacity: 1;
    visibility: visible;
  }

  &.loggedIn::after {
    background: map.get(colors.$themeColors, color-background-1);
  }
}

.triangle::after {
  content: "";
  position: absolute;
  width: 14px;
  height: 14px;
  background: #fff;
  transform: rotate(45deg);
  top: 17px;
  left: 5px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
}

.popup {
  position: absolute;
  top: calc(100% + 18px);
  right: 0;
  max-width: 100vw;
  background-color: white;
  color: map.get(colors.$themeColors, color-primary-text);
  transition: map.get(other.$otherUtils, global-transition);
  z-index: map.get(other.$otherUtils, z-dropdown);
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
  opacity: 0;
  visibility: hidden;

  &.open {
    opacity: 1;
    visibility: visible;
  }
}

.content.loggedIn {
  width: 415px;
}
</style>
